import * as z from "zod/v4";

export const setDeposcoIntegration = {
  name: "setDeposcoIntegration" as const,
  input: z.object({
    businessUnit: z.string().min(1, "Business unit is required"),
    refreshToken: z.string().min(1, "Refresh token is required"),
  }),
  output: z.object({}),
};

export type SetDeposcoIntegrationInput = z.infer<
  typeof setDeposcoIntegration.input
>;

export const updateDeposcoIntegration = {
  name: "updateDeposcoIntegration" as const,
  input: z.object({ businessUnit: z.string().min(1).optional() }),
  output: z.object({}),
};

export type UpdateDeposcoIntegrationInput = z.infer<
  typeof updateDeposcoIntegration.input
>;

export const getDeposcoIntegration = {
  name: "getDeposcoIntegration" as const,
  input: z.object({}),
  output: z.object({
    deposcoIntegration: z.optional(
      z.object({ businessUnit: z.string(), lastSyncTime: z.date().nullable() }),
    ),
  }),
};

export type GetDeposcoIntegrationOutput = z.infer<
  typeof getDeposcoIntegration.output
>;

export const disconnectDeposcoIntegration = {
  name: "disconnectDeposcoIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
